import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from "axios";
import config from "./config";

const baseConfig: AxiosRequestConfig = {
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
};

const axiosChartInstance = axios.create({
  baseURL: config.chartApiBaseUrl,
  ...baseConfig,
});

const axiosIdentityInstance = axios.create({
  baseURL: config.identityApiBaseUrl,
  ...baseConfig,
});

const axiosPatientInstance = axios.create({
  baseURL: config.patientApiBaseUrl,
  ...baseConfig,
});

const axiosFacilityInstance = axios.create({
  baseURL: config.facilityApiBaseUrl,
  ...baseConfig,
});

const axiosTimerInstance = axios.create({
  baseURL: config.timerApiBaseUrl,
  ...baseConfig,
});

const axiosOrderInstance = axios.create({
  baseURL: config.orderApiBaseUrl,
  ...baseConfig,
});

const axiosChartEngineInstance = axios.create({
  baseURL: config.chartEngineApiBaseUrl,
  ...baseConfig,
});

const axiosSLPatientInstance = axios.create({
  baseURL: config.SLPatientApiBaseUrl,
  withCredentials: false,
});

const axiosInstances = {
  axiosChartInstance,
  axiosIdentityInstance,
  axiosPatientInstance,
  axiosFacilityInstance,
  axiosTimerInstance,
  axiosOrderInstance,
  axiosSLPatientInstance,
  axiosChartEngineInstance,
};

// Add response interceptors for handling 401/403 errors
const setupAuthInterceptors = (instance: AxiosInstance) => {
  instance.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
      const status = error.response?.status;

      // Handle unauthorized/forbidden errors - redirect to logout
      if (status === 401 || status === 403) {
        const logoutUrl = config.auth0LogoutUrl || window.location.origin;
        window.location.href = logoutUrl;
      }

      return Promise.reject(error);
    }
  );
};

// Apply interceptors to all instances except SLPatient (external service)
Object.entries(axiosInstances).forEach(([name, instance]) => {
  if (name !== "axiosSLPatientInstance") {
    setupAuthInterceptors(instance);
  }
});

export {
  axiosChartInstance,
  axiosIdentityInstance,
  axiosPatientInstance,
  axiosFacilityInstance,
  axiosTimerInstance,
  axiosOrderInstance,
  axiosSLPatientInstance,
  axiosChartEngineInstance,
};
export default axiosInstances;
